import { render, staticRenderFns } from "./image.component.vue?vue&type=template&id=d558c854&scoped=true&"
import script from "./image.component.vue?vue&type=script&lang=js&"
export * from "./image.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d558c854",
  null
  
)

export default component.exports